// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__1R97I","cell":"ColumnAccessor_cell__3Oqeu","firstCellAccent":"ColumnAccessor_firstCellAccent__yGpir"};